export default "__VITE_ASSET__DNQ5mm5s__"